import { useState } from 'react';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import BorderGradient from 'components/shared/BorderGradient/BorderGradient';
import Switch from 'components/shared/Switch';

interface Role {
    id: string;
    name: string;
    description: string;
    isActive: boolean;
    permissions: string[];
    createdAt: string;
}

interface RolesTableProps {
    roles: Role[];
    onUpdateRole: (role: Role) => void;
    onEdit: (role: Role) => void;
}

export default function RolesTable({ roles, onUpdateRole, onEdit }: RolesTableProps) {
    const handleEdit = (role: Role) => {
        onEdit(role);
    };

    const handleToggleStatus = (role: Role) => {
        onUpdateRole({
            ...role,
            isActive: !role.isActive
        });
    };

    const handleDelete = (role: Role) => {
        // Handle delete
    };

    return (
        <div className="">

<div className="sticky top-[160px] bg-black z-10 pt-4">
            <div className="bg-[#2A2A2A] rounded-lg overflow-hidden">
                <table className="w-full table-fixed">
                    <thead>
                            <tr className="bg-[#1A1A1A] text-gray-400 text-sm">
                                <th className="text-left py-3 px-4 w-[11%]">Role Name</th>
                                <th className="text-left py-3 px-4 w-[11%]">Description</th>
                                <th className="text-center py-3 px-4 w-[11%]">Status</th>
                                <th className="text-right py-3 px-4 w-[11%]">Action</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>

            <div className="bg-[#2A2A2A] rounded-lg overflow-hidden">
                <div className=" ">
                    <table className="w-full table-fixed">
                        <tbody>
                            {roles.map((role) => (
                                <tr 
                                    key={role.id} 
                                    className="border-b border-white/[0.08] hover:bg-[#3a3a3a33]"
                                >
                                    <td className="py-3 px-4 w-[11%]">
                                        <span className="text-white">{role.name}</span>
                                    </td>
                                    <td className="py-3 px-4 text-gray-400 max-w-xl w-[11%]">
                                        <span className="line-clamp-1">{role.description}</span>
                                    </td>
                                    <td className="py-3 px-4 w-[11%]">
                                        <div className="flex justify-center">
                                            <Switch
                                                checked={role.isActive}
                                                onChange={() => handleToggleStatus(role)}
                                            />
                                        </div>
                                    </td>
                                    <td className="py-3 px-4 text-right w-[11%]">
                                        <div className="flex items-center justify-end gap-2">
                                            <button 
                                                onClick={() => handleEdit(role)}
                                                className="p-2 hover:bg-white/[0.08] rounded-lg text-gray-400 hover:text-white"
                                            >
                                                <FiEdit2 size={16} />
                                            </button>
                                            <button 
                                                onClick={() => handleDelete(role)}
                                                className="p-2 hover:bg-white/[0.08] rounded-lg text-gray-400 hover:text-red-400"
                                            >
                                                <FiTrash2 size={16} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
} 